import React, { Suspense } from "react";
import FlashMessage from "./shared/FlashMessage";
import SchoolBridgeLoader from "./shared/SchoolBridgeLoader";
import buildLazyScreenResolver from "./buildLazyScreenResolver";

const publicScreenContext = require.context("./screens", true, /^\.\/Public.*\.js$/, "lazy");
const resolveScreenComponent = buildLazyScreenResolver(publicScreenContext);

export default function PublicApp(props) {
  const { view } = props;
  const ScreenComponent = resolveScreenComponent(view);
  const initialFlashMessages = [
    props.alertMessage ? { message: props.alertMessage, mode: "error" } : null,
    props.noticeMessage ? { message: props.noticeMessage, mode: "notice" } : null
  ].filter(Boolean);

  if (ScreenComponent) {
    return (
      <>
        <FlashMessage initialMessages={initialFlashMessages} />
        <Suspense fallback={<div className="p-6 lg:p-8"><SchoolBridgeLoader /></div>}>
          <ScreenComponent {...props} />
        </Suspense>
      </>
    );
  }

  return <div>{SchoolBridge.translations.general.unknown_view} {view}</div>;
}
